import { createSharedComposable } from '@vueuse/core'
import { ref, watch } from 'vue'
import { useBreakpoints } from '@/layout/composables/useBreakpoints'

// Shared reactive state for mobile drawer
export const useValuerSidebarDrawer = createSharedComposable(() => {
  const { isDesktop } = useBreakpoints()
  const mobileDrawerOpen = ref(false)

  watch(
    isDesktop,
    (value) => {
      if (value)
        mobileDrawerOpen.value = false
    },
  )

  return {
    mobileDrawerOpen,
    openDrawer: () => {
      mobileDrawerOpen.value = true
    },
    closeDrawer: () => {
      mobileDrawerOpen.value = false
    },
  }
})
